import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import inquirySevice from "../../../services/inquirySevice";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Inquiry = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inquiry, setInquiry] = useState(null);

  useEffect(() => {
    const fetchInquiry = async () => {
      try {
        const res = await inquirySevice.getOneInquiry(instanceToken.token, id);
        setInquiry(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchInquiry();
  }, [id]);

  const handleRemove = async () => {
    try {
      await inquirySevice.deleteInquiry(instanceToken.token, id);
      homeAlert("Inquiry has been removed.", false);
      navigate("/inquiry");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  const toggleStatus = async () => {
    try {
      const res = await inquirySevice.updateInquiry(instanceToken.token, id);
      setInquiry(res.data);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Inquiry Details"
      subtitle="View and manage customer inquiry"
      breadcrumbs={[
        { label: "Inquiry", path: "/inquiry" },
        { label: `Inquiry (ID - ${id})` },
      ]}
      listPath="/inquiry"
      loading={!inquiry}
      onRemove={handleRemove}
      footerStart={
        inquiry ? (
          <button
            type="button"
            className={`detail-btn detail-btn-status${
              inquiry.service_request_checked ? "" : " detail-btn-status--warning"
            }`}
            onClick={toggleStatus}
          >
            {inquiry.service_request_checked ? "Completed" : "Revert"}
          </button>
        ) : null
      }
      contentSections={
        inquiry?.message
          ? [
              {
                title: "Message",
                value: inquiry.message,
                icon: "notes",
              },
            ]
          : []
      }
      infoItems={
        inquiry
          ? [
              { label: "ID", value: String(inquiry.id), icon: "id" },
              {
                label: "Product Name",
                value: inquiry.product_name,
                icon: "title",
              },
              {
                label: "Inquirer Name",
                value: inquiry.inquirer_name,
                icon: "person",
              },
              {
                label: "Phone Number",
                value: inquiry.phone_number,
                icon: "phone",
              },
              {
                label: "Status",
                value: inquiry.service_request_checked
                  ? "Completed"
                  : "Pending",
                icon: "info",
              },
              ...dateInfoItems(inquiry),
            ]
          : []
      }
      infoTitle="Inquiry Information"
    />
  );
};

export default Inquiry;
